export const createCurvedPath = (s, d) =>
  `M ${s.y} ${s.x}
  C ${(s.y + d.y) / 2} ${s.x},
  ${(s.y + d.y) / 2} ${d.x},
  ${d.y} ${d.x}`;
export const TRANSITION_DURATION = 750;
export const HORIZONTAL_NODE_DISTANCE = 200;
export const MAX_ZOOM = 3;
export const MIN_ZOOM = 0.2;
export const CIRCLE_RADIUS = 8;
export const MIN_NODE_VERTICAL_SPACE = 25;
export const INITIAL_LEFT_MARGIN = 250;
export const MAX_NODE_CHAR_COUNT = 30;
